// JsFromRoutes CacheKey 99964c1a76c420970088f1e86711e505
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  claim: /* #__PURE__ */ definePathHelper('post', '/human-verification/:token'),
}
